import { Link } from "react-router-dom";

export default function Cta() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="relative overflow-hidden rounded-lg">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20stylized%20anime%20manga%20illustration%20of%20open%20comic%20books%20and%20dynamic%20action%20scenes%20in%20warm%20coral%20and%20golden%20amber%20palette%2C%20abstract%20artistic%20background%20for%20call%20to%20action%2C%20dark%20moody%20edges%2C%20energetic%20composition&width=1600&height=500&seq=cta-manga&orientation=landscape"
            alt="开启追更旅程背景"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/55 to-black/25"></div>
        </div>
        <div className="relative z-10 flex flex-col items-start justify-center gap-5 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-12 md:py-16">
          <div className="max-w-xl">
            <h2 className="font-heading text-2xl text-background-50 md:text-3xl">
              加入追更，从此告别等待
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100 md:text-base">
              数百部长期连载神作正在稳定更新，选择你心仪的题材，开启属于你的追更旅程。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/series"
              className="whitespace-nowrap rounded-md bg-accent-500 px-7 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
            >
              浏览全部连载
            </Link>
            <Link
              to="/contact"
              className="whitespace-nowrap rounded-md border border-background-50/50 bg-black/20 px-7 py-3 text-sm font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-black/30"
            >
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}